import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, Fragment } from "react";
import { cx } from "@emotion/css";
import { Text } from "../text";
import "./ListTable.scss";
export const Table = ({ ...props }) => {
    const renderEmptyTable = () => (_jsx("tbody", { children: _jsx("tr", { children: _jsx("td", { colSpan: Children.count(props.children), className: "table__no-rows-renderer", children: typeof props.noRowsMessage === "string" ? (_jsx(Text, { fontSize: "1.25em", fontWeight: "medium", color: "gray100", children: props.noRowsMessage ? props.noRowsMessage : "No results found" })) : (props.noRowsMessage) }) }) }));
    const renderHeader = () => props.data.length === 0 && props.noRowsMessage ? undefined : (_jsx("thead", { children: _jsx("tr", { children: Children.map(props.children, (columnElement, idx) => {
                return (_jsx("th", { style: columnElement.props.width &&
                        (props.widthPercent
                            ? { width: `${columnElement.props.width}%` }
                            : { width: `${columnElement.props.width}px` }), "data-test-id": `header-${columnElement.props.label}`, children: columnElement.props.label }, idx));
            }) }) }));
    const renderBody = () => (_jsx("tbody", { children: props.data.map((rowData, rowIdx) => (_jsxs(Fragment, { children: [_jsx("tr", { role: "button", className: cx(props.basic
                        ? "list-table-basic__row"
                        : `list-table__row list-table__row-${props.getRowId?.({
                            rowData,
                            rowIndex: rowIdx,
                        })}`, {
                        "list-table__row--clickable": !!props.onRowClick,
                    }, props.activeRowIndex === rowIdx && "active", props.onHoverRow && "hoverable"), onClick: () => {
                        const row = { rowData, rowIndex: rowIdx };
                        if (props.onRowClick) {
                            props.onRowClick(props.getRowId(row), row);
                        }
                    }, style: {
                        // @ts-expect-error - this is a valid style prop
                        "&:hover": {
                            backgroundColor: "red",
                        },
                    }, onMouseOver: () => props.onHoverRow?.(rowIdx), onMouseLeave: () => props.onHoverRow?.(null), children: Children.map(props.children, (columnElement, cellIdx) => (_jsx("td", { "aria-hidden": "true", onClick: () => {
                            const row = { rowData, rowIndex: rowIdx };
                            if (props.onButtonClick) {
                                props.onButtonClick(props.getRowId(row), row);
                            }
                            if (props.onIconClick && columnElement.props.iconClick) {
                                props.onIconClick(props.getRowId(row), row);
                            }
                        }, style: {
                            width: columnElement.props.width &&
                                (props.widthPercent
                                    ? `${columnElement.props.width}%`
                                    : `${columnElement.props.width}px`),
                            background: "transparent",
                        }, children: columnElement.props.cellRenderer({
                            rowIndex: rowIdx,
                            rowData,
                        }) }, cellIdx))) }), !props.basic && (_jsxs(_Fragment, { children: [_jsx("tr", { className: `list-table__empty-row list-table__empty-row-${props.getRowId?.({
                                rowData,
                                rowIndex: rowIdx,
                            })}`, children: _jsx("td", { colSpan: Children.count(props.children) }) }), props.activeRowId ===
                            props.getRowId?.({
                                rowData,
                                rowIndex: rowIdx,
                            }) && (_jsx("tr", { className: "list-table__empty-row", children: _jsx("td", { colSpan: Children.count(props.children) }) }))] }))] }, rowIdx))) }));
    return (_jsxs("table", { className: cx({
            "list-table": !props.basic,
            "list-table-basic": props.basic,
            "no-row-border": props.noRowBorder,
        }), children: [renderHeader(), renderBody(), props.data.length === 0 && renderEmptyTable()] }));
};
